<template>
  <!--地图-->
  <div>
    <el-input type="text" size="mini" id="searchAddres" v-model="searchAddresKeywords" placeholder="搜索"
              style="width: 40%;margin: 10px;position: relative;z-index: 9999999"></el-input>
    <div id="baidu-map-container" style="width: 100%; height: 500px;margin-top: -50px">
    </div>
    <div style="padding: 5px;color: #000;font-size: 16px">
      <div>
        省市区: <span style="font-weight: 600" v-if="addressInfo.district">{{ addressInfo.province }}/{{
          addressInfo.city
                                                                        }}/{{ addressInfo.district }}</span>
        <span style="font-weight: 600" v-else>请选择</span>
      </div>
      <div style="margin-top: 5px">
        详细地址:
        <el-input size="mini" placeholder="请输入详细地址" style="width: 40%;margin-left: 10px;color: #000"
                  v-model="addressInfo.address"></el-input>
      </div>


    </div>
    <div slot="footer" class="dialog-footer" style="margin-top: 10px;text-align: center">
      <el-button type="primary" style="width: 200px" @click="confirmSelect" size="mini">确 定</el-button>
    </div>
  </div>
</template>
<script>

import u from "@/assets/js/util"

export default {
  data() {
    return {
      searchAddresKeywords: "",
      addressInfo: {
        // 地址信息
        longitude: "", // 经度
        latitude: "", // 纬度
        province: "", // 省
        city: "", // 市
        district: "", // 区
        address: "", // 详细地址
      },
      openMap: false,
    };
  },
  async mounted() {
    try {
      this.initBaiduMap(point.x, point.y)
    } catch (e) {
      this.initBaiduMap(104.076195, 30.631462)
    }
  },
  methods: {
    // 初始化百度地图
    initBaiduMap(lng, lat) {
      let that = this;
      this.$nextTick(function () {
        /** 初始化地图Start */
        var map = new BMap.Map("baidu-map-container"); // 创建地图实例
        var point = new BMap.Point(lng, lat); // 设置中心点坐标
        map.centerAndZoom(point, 11); // 地图初始化，同时设置地图展示级别
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
        /** 初始化地图End */
        /** 点击地图创建坐标事件Start */
        // 添加地图点击事件
        map.addEventListener("click", function (e) {
          var clickpt = e.point; // 点击的坐标
          map.clearOverlays(); // 移除地图上的标注
          var marker = new BMap.Marker(clickpt); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          // 逆地址解析
          that.geocAddress(clickpt);
        });
        /** 点击地图创建坐标事件End */
        /** 搜索地址Start */
          // 建立一个自动完成的对象
        var ac = new BMap.Autocomplete({
            input: "searchAddres",
            location: map,
          });
        // 鼠标点击下拉列表后的事件
        ac.addEventListener("onconfirm", function (e) {
          map.clearOverlays(); // 移除地图上的标注
          var local = new BMap.LocalSearch(map, {
            //智能搜索
            onSearchComplete: function (results) {
              let poi = results.getPoi(0); //获取第一个智能搜索的结果
              var searchpt = poi.point; // 获取坐标
              map.centerAndZoom(searchpt, 16);
              map.addOverlay(new BMap.Marker(searchpt)); //添加标注
              that.geocAddress(searchpt); // 逆地址解析
            },
          });
          // 搜索词
          var searchValue = e.item.value;
          local.search(
            searchValue.province +
            searchValue.city +
            searchValue.district +
            searchValue.street +
            searchValue.business
          );
        });
        /** 搜索地址End */
      });
    },
    /** 逆向解析地址 point */
    geocAddress(point) {
      let that = this;
      var geoc = new BMap.Geocoder();
      geoc.getLocation(point, function (geocInfo) {
        // 设置基本信息
        var addressInfo = geocInfo.addressComponents;
        that.addressInfo.longitude = point.lng;
        that.addressInfo.latitude = point.lat;
        that.addressInfo.province = addressInfo.province;
        that.addressInfo.city = addressInfo.city;
        that.addressInfo.district = addressInfo.district;
        let address = addressInfo.street + addressInfo.streetNumber;
        if (geocInfo.surroundingPois.length > 0) {
          address = address + geocInfo.surroundingPois[0].title;
        }
        that.addressInfo.address = address;
      });
    },
    /** 打开地图选择 */
    show() {
      this.openMap = true;
      this.initBaiduMap();
    },
    /**
     * 确认选择
     */
    confirmSelect() {
      if (!this.addressInfo.address) {
        u.error("请输入详细地址")
        return
      }
      this.$emit("confirmMapAddress", this.addressInfo);
    },
  },
};
</script>

<style>
.tangram-suggestion {
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/page/module/util/map.vue